import { USE_BACKEND } from '../config/env';
import { databricksServiceApi } from './databricksService.api';
import { databricksServiceMock } from './databricksService.mock';
import type { DatabricksServiceApi } from '../types/databricks';

// Smart loader that returns API or mock based on USE_BACKEND flag
export const databricksService: DatabricksServiceApi = USE_BACKEND ? databricksServiceApi : databricksServiceMock;
